import styled from 'styled-components'

import TextFieldC from '../../form/TextField'
import FormSubmitErrors from '../../form/FormSubmitErrors'
import SubmitButton from '../../form/SubmitButton'
import FormikForm from '../../form/FormikForm'
import Select from '../../form/Select'
import breakpoints from '../../../theme/breakpoints'
import ActionButton from '../../ActionButton'

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Fields = styled.div`
  width: 100%;

  & > * {
    &:not(:first-child) {
      margin-top: 15px;
    }
  }
`

export const TextField = styled(TextFieldC)``

export const SelectField = styled(Select)``

export const HorizontalFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  ${breakpoints.up('md')} {
    flex-direction: row;
    gap: 20px;
  }
`

export const SubmitErrors = styled(FormSubmitErrors)`
  margin-top: 30px;
`

export const Buttons = styled.div`
  width: 100%;
  margin-top: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`

export const Submit = styled(SubmitButton)`
  width: 100%;
  max-width: 250px;
`

export const EditButton = styled(ActionButton)`
  min-width: max-content;
  width: max-content;
`
